<template>
	<div class="return-at-nav-module">
		<div id="return-at-nav-body">
		<h3 class="module-title">
			Returns at NAV
			<slot name="superscript1" />
		</h3>
		<span v-if="returnAtNavData.showReadMoreLink">
			<ReadMoreLink />
		</span>
		<div class="row return-nav-data-container">
			<div />
			<div class="col-sm-3 col-xs-4 return-nav-column">
				<div class="return-nav-value">
					{{ returnAtNavData.Nav1yr.data }}
				</div>
				<div class="return-nav-label">
					{{ returnAtNavData.Nav1yr.label }}
				</div>
			</div>
			<div class="col-sm-3 col-xs-4 return-nav-column">
				<div class="return-nav-value">
					{{ returnAtNavData.Nav5yr.data }}
				</div>
				<div class="return-nav-label">
					{{ returnAtNavData.Nav5yr.label }}
				</div>
			</div>
			<div v-if="returnAtNavData.showLifeTimeData" class="col-sm-3 col-xs-4 return-nav-column">
				<div class="return-nav-value">
					{{ returnAtNavData.NavLife.data }}
				</div>
				<div class="return-nav-label" v-html="returnAtNavData.NavLife.label" />
			</div>
			<div v-else class="col-sm-3 col-xs-4 return-nav-column">
				<div class="return-nav-value">
					{{ returnAtNavData.Nav10yr.data }}
				</div>
				<div class="return-nav-label">
					{{ returnAtNavData.Nav10yr.label }}
				</div>
			</div>
			<div class="col-sm-3 col-xs-12 return-nav-column">
				<div class="return-nav-value">
					{{ returnAtNavData.Sec30DayYield.data }}
				</div>
				<div class="return-nav-label">
					{{ returnAtNavData.Sec30DayYield.label }}
					<i-ball-modal tag="SECYield" />
				</div>
			</div>
		</div>
		<div class="sub-info adjust-date">
			{{ returnAtNavData.AsOfDate }}
		</div>
	</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ReadMoreLink from '_components_/Shared/ReadMoreLink.vue';
export default {
	name: 'ReturnsAtNAV',
	components: {
		ReadMoreLink
	},
	// errorCaptured(error, vm, info) {
	// 	console.error('error in disclosure Superscript: ', error, vm, info);
	// 	console.error('LOG error in disclosure Superscript: ', error, vm, info);
	// },
	data() {
		return {
			lifeTimeDataObjectives: [
				'equityincome',
				'balanced',
				'portfolioseries'
			]
		};
	},
	computed: {
		...mapGetters([
			'getReturnsAtNav',
			'getAudience',
			'getFundAttributes'
		]),
		returnAtNavData() {
			const navData = this.getReturnsAtNav || {
				Nav1yr: { data: '--', label: '1-year return' },
				Nav5yr: { data: '--', label: '5-year return' },
				Nav10yr: { data: '--', label: '10-year return' },
				NavLife: { data: '--', label: `Lifetime Return` },
				Sec30DayYield: { data: '--', excelLabel: '30-Day SEC Yield (Fund at NAV)', asOfDate: `Yield as of -- (updated monthly).`, label: '30-Day SEC Yield' },
				AsOfDate: `Returns as of -- (updated monthly). Yield as of -- (updated monthly).`,
				AgeOfFund: null
			};
			return Object.assign({}, navData, {
				showReadMoreLink: true,
				showLifeTimeData: this.shouldShowLifeTimeData
			});
		},
		shouldShowLifeTimeData() {
			const objective = this.getFundAttributes && this.getFundAttributes.Objective || '';
			const fundSymbol = this.getFundAttributes && this.getFundAttributes.FundSymbol || '';
			const lowerCaseObj = objective.replace(/\s/g, '').toLowerCase();
			return (this.lifeTimeDataObjectives.includes(lowerCaseObj)
				|| (this.getReturnsAtNav && Object.prototype.hasOwnProperty.call(this.getReturnsAtNav, 'AgeOfFund') && this.getReturnsAtNav.AgeOfFund !== null && this.getReturnsAtNav.AgeOfFund < 10)
				|| fundSymbol === 'VIMF');
		}
	}
};
</script>
<style scopred lang="less">
@import '~_css_/variables';

#return-at-nav-body {
	margin-bottom: 40px;
	.module-border-top();
	margin-top: 0;
	padding: 0;

	a {
		display: block;
		font-family: Avenir Next LT W01 Demi, Arial, sans-serif;
		font-weight: 700;
		margin-bottom: 13px;
	}

	.return-nav-column:nth-of-type(5) {
		padding-left: 30px;
		padding-right: 13px;
		border-left: 1px solid #ccc;
	}

	.sub-info {
		font-size: 12px;
		margin-top: 15px;
	}

	.return-nav-column {
		font-family: "AvenirNextLTW01-Regular", Arial;

		.return-nav-value {
			color: @dark-gray;
			font-size: 18px;
		}

		.return-nav-label {
			color: @gray;
			font-size: 12px;
		}
	}

	@media (max-width: 768px) {
		.sub-info {
			margin-bottom: 35px;
		}
	}

	@media (max-width: 480px) {
		.return-nav-data-container {
			flex-wrap: wrap;
			.module-border-top();
			padding-top: 10px;
			padding-bottom: 10px;

			.return-nav-column {
				width: 33.333%;

				&:last-child {
					border: none;
					padding: 0;
					width: 100%;
					padding-left: 10px;
				}

				.return-nav-value {
					margin: 0;
					width: max-content;
					max-width: 100%;
					text-align: left;
					font-family: "AvenirNextLTW01-regular";

					&:first-child {
						font-size: 18px;
					}

					&:last-child {
						font-size: 12px;
					}
				}
			}
		}

		.sub-info {
			margin-bottom: 20px;
		}

		.adjust-date {
			.module-border-top();
			padding-top: 15px;
		}
	}
}
</style>
